import React from 'react';
import CanvasJSReact from '../Assets/JS/canvasjs-2.3.2/canvasjs.react';

export default class OnlineCountChart extends React.Component {
  componentDidMount() {
    setInterval(this.UpdateChart, this.props.UpdateInterval || 1000);
  }

  UpdateChart = () => {
    if (!this.Chart) return;

    let dpsColor,
      dpsTotal = 0,
      deltaY,
      yVal;

    let dps = this.Chart.options.data[0].dataPoints;

    for (let i = 0; i < dps.length; i++) {
      deltaY = Math.round(2 + Math.random() * (-2 - 2));

      yVal = deltaY + dps[i].y > 0 ? dps[i].y + deltaY : 0;

      const Percent = yVal / 50;

      dpsColor =
        Percent >= 90
          ? '#e40000'
          : Percent >= 70
          ? '#ec7426'
          : Percent >= 50
          ? '#81c2ea'
          : '#88df86 ';

      dps[i] = {
        label: [
          'Website',
          'Game',
          'Single IP/PC',
          'Bot',
          'EU',
          'CH',
          'Hunter',
          'Trader',
          'Thief',
          'Male',
          'Female'
        ][i],
        y: yVal,
        color: dpsColor
      };

      if (i === 0) dpsTotal = yVal;
    }

    this.Chart.options.data[0].dataPoints = dps;
    this.Chart.options.title.text = `Online Players: ${dpsTotal}`;

    this.Chart.render();
  };

  render() {
    const options = {
      theme: 'light2',
      height: 240,
      title: { text: 'Online Players' },
      subtitles: [{ text: 'Server Name: Hazar' }],
      axisY: { maximum: 5000 },
      data: [
        {
          type: 'column',
          yValueFormatString: '#',
          indexLabel: '{y}',
          dataPoints: [
            { label: 'Website', y: 3200 },
            { label: 'Game', y: 2315 },
            { label: 'Single IP/PC', y: 340 },
            { label: 'Bot', y: 120 },
            { label: 'EU', y: 900 },
            { label: 'CH', y: 900 },
            { label: 'Hunter', y: 900 },
            { label: 'Trader', y: 520 },
            { label: 'Thief', y: 1100 },
            { label: 'Male', y: 900 },
            { label: 'Female', y: 900 }
          ]
        }
      ]
    };

    return (
      <div>
        <CanvasJSReact.CanvasJSChart
          options={options}
          onRef={ref => (this.Chart = ref)}
        />
      </div>
    );
  }
}
